import { v4 as uuidv4 } from 'uuid'
import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { Network, PlugToken } from '../../interfaces/common'

interface DevModeStore {
  devEnabled: boolean
  setDevModeEnabled: (enabled: boolean) => void
  activeNetwork?: string
  networks: { [key: string]: Network }
  addNetwork: (name: string, hostUrl: string) => string
  updateNetwork: (id: string, name: string, hostUrl: string) => void
  networkTokens: { [key: string]: PlugToken[] }
  addTokenToNetwork: (id: string, token: PlugToken) => void
  removeTokenFromNetwork: (id: string, token: PlugToken) => void
  setActiveNetwork: (id: string) => void
}

export const createDevModeStore = (storage: StateStorage) =>
  createStore<DevModeStore>(
    storage,
    (set, get) => ({
      devEnabled: false,
      setDevModeEnabled(devEnabled) {
        set({ devEnabled })
      },
      networks: {},
      networkTokens: {},
      addNetwork(name, hostUrl) {
        const { networks } = get()
        const id = uuidv4() as string

        set({
          networks: {
            ...networks,
            [id]: { id, name, hostUrl },
          },
          activeNetwork: id,
        })

        return id
      },
      updateNetwork(id, name, hostUrl) {
        const { networks } = get()
        set({
          networks: {
            ...networks,
            [id]: {
              id,
              name,
              hostUrl,
            },
          },
        })
      },
      addTokenToNetwork(id, token) {
        const networkTokens = get().networkTokens
        const existingNetworkTokens = networkTokens[id] || []
        set({
          networkTokens: {
            ...networkTokens,
            [id]: [...existingNetworkTokens, token],
          },
        })
      },
      removeTokenFromNetwork(id, token) {
        const networkTokens = get().networkTokens
        const existingNetworkTokens = networkTokens[id] || []
        set({
          networkTokens: {
            ...networkTokens,
            [id]: existingNetworkTokens.filter((token) => token.id !== token.id),
          },
        })
      },
      setActiveNetwork(id) {
        set({ activeNetwork: id })
      },
    }),
    {
      persist: {
        name: 'devMode',
        version: 0,
      },
    }
  )
